
import Vue from 'vue'

export default Vue.extend({
  name: 'PricingDetailsCard',
  props: {
    title: { type: String, default: 'Title' },
    seatsCnt: { type: Number, default: 0 },
    proAccessesCnt: { type: Number, default: 0 },
    premiumAccessesCnt: { type: Number, default: 0 },
    nextInvoiceIssueDate: { type: String, default: '1994.03.21' },
    licenceFee: { type: String, default: '-' },
    membershipFee: { type: String, default: '-' },
    subscriptionFee: { type: String, default: '-' },
    billingPeriod: { type: String, default: 'invalid' },
    currency: { type: String, default: 'invalid' },
    isHidePrice: { type: Boolean, default: false },
  },
})
